import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { LOGIN_URL, SITE_MAINTENANCE_URL } from '../constants/constants';
import { setMaintenanceStatus } from 'src/ui/features/Maintenance/state/maintenanceActions';

function requireAuth(Component, required = true) {
  class AuthenticatedComponent extends React.Component {
    render() {
      const { setMaintenanceStatus, isInProgress } = this.props;
      setMaintenanceStatus();
      // If there is a maintenance process in progress, It should redirect to the Maintenance page
      if (isInProgress) {
        return <Redirect to={SITE_MAINTENANCE_URL} />;
      }
      const isSessionActive = sessionStorage.getItem('isSessionActive') || false;
      return isSessionActive || !required ? <Component {...this.props} /> : <Redirect to={LOGIN_URL} />;
    }
  }
  const mapStateToProps = ({ maintenance }) => {
    return {
      isInProgress: maintenance.isInProgress,
    };
  };
  const mapDispatchToProps = {
    setMaintenanceStatus,
  };
  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AuthenticatedComponent);
}

export default requireAuth;
